export const SummaryCardsName = {
  PROGRAM: 'Program',
  PURPOSE: 'Purpose',
  INTEREST_RATE: 'Interest Rate',
  MORTGAGE_INSURANCE: 'Mortgage Insurance',
};

const SummaryCardsKey = {
  PROGRAM: 'program',
  PURPOSE: 'purpose',
  INTEREST_RATE: 'interestRate',
  MORTGAGE_INSURANCE: 'mortgageInsurance',
};

const summaryCardsOptions = [
  { name: SummaryCardsName.PROGRAM, value: SummaryCardsKey.PROGRAM },
  { name: SummaryCardsName.PURPOSE, value: SummaryCardsKey.PURPOSE },
  { name: SummaryCardsName.INTEREST_RATE, value: SummaryCardsKey.INTEREST_RATE },
  { name: SummaryCardsName.MORTGAGE_INSURANCE, value: SummaryCardsKey.MORTGAGE_INSURANCE },
];

const UNSECURED_HIDDEN_CARD_NAMES = [SummaryCardsName.PURPOSE, SummaryCardsName.MORTGAGE_INSURANCE];
const CHATTEL_HIDDEN_CARD_NAMES = [SummaryCardsName.MORTGAGE_INSURANCE];

export const getVisibleSummaryCardsOptions = ({ isUnsecured = false, isChattel = false } = {}) =>
  summaryCardsOptions.filter(({ name }) => {
    if (isUnsecured && UNSECURED_HIDDEN_CARD_NAMES.includes(name)) {
      return false;
    }

    if (isChattel && CHATTEL_HIDDEN_CARD_NAMES.includes(name)) {
      return false;
    }

    return true;
  });

const baseProgramOptions = [
  { name: 'Loan Type', key: 'loanType' },
  { name: 'Amortization Type', key: 'amortizationType' },
  { name: 'Loan Term', key: 'loanTerm' },
  { name: 'Amortization Term', key: 'amortizationTerm' },
];

const investorProgramOption = { name: 'Investor', key: 'investorName' };

const escrowProgramOption = { name: 'Escrow', key: 'escrow' };

const interestOnlyProgramOptions = [{ name: 'I/O / Repayment', key: 'ioPeriods' }];

export const getProgramOptions = (program = {}, { isUnsecured = false } = {}) => {
  const options = [...baseProgramOptions];

  // Chattel escrows like a standard loan (IMP-495 / owner decision 5, 2026-07-05):
  // the backend escrow exemption was removed for Chattel (SkynetCore #8666), so the
  // Escrow card renders for Chattel now — only Unsecured stays exempt.
  if (!isUnsecured) {
    options.push(escrowProgramOption);
  }

  if (program.interestOnly && program.ioPeriods) {
    options.push(...interestOnlyProgramOptions);
  }

  if (program.investorName) {
    options.push(investorProgramOption);
  }

  return options;
};

const mortgageInsuranceOptions = [
  { name: 'MI Coverage %', key: 'miCoveragePercent' },
  { name: 'PMI Rate %', key: 'pmiPercent' },
  { name: 'Monthly PMI', key: 'pmi' },
  { name: 'MI Term (months)', key: 'miTerm' },
  { name: 'MI & Funding Fee Financed', key: 'miAndFundingFeeFinancedAmount' },
  { name: 'MI & Funding Fees Total', key: 'miAndFundingFeesAmount' },
];

const interestRateOptions = [
  { name: 'Lock Date', key: 'lockDate' },
  { name: 'Lock Expiration', key: 'lockExpiration' },
  { name: 'Lock Term', key: 'lockTerm' },
  { name: 'Adjustments', key: 'adjustments' },
  { name: 'Buy Price', key: 'buyPrice' },
  { name: 'Final Price', key: 'finalPrice' },
];

export const loanDetailsOptions = {
  [SummaryCardsKey.INTEREST_RATE]: interestRateOptions,
  [SummaryCardsKey.MORTGAGE_INSURANCE]: mortgageInsuranceOptions,
};

export const SUMMARY_SKELETONS_LENGTH = 4;
